import styled, { css } from 'styled-components'
import { colors } from '@/styles'
import { Label } from '@/components/text'
import Tooltip from '@/components/popper-tooltip'
import Icon from '@/components/icon'

export type StatusBadgeType = 'success' | 'default'

type Color = 'primary' | 'secondary'

type StatusBadgeProps = {
  type: StatusBadgeType
  size?: 'small' | 'medium'
  space?: 'fit' | 'full'
  title: string
  tooltip?: React.ReactNode
  tooltipTheme?: Color
  toolTipIcon?: boolean
  isLocked?: boolean
}

type StyleProps = Omit<StatusBadgeProps, 'title' | 'tooltip'>

const success = css`
  color: ${colors.green48};
  cursor: auto;
`

const full = css`
  width: 100%;
  div {
    width: 100%;
    text-align: center;
  }
`

const getTypeStyles = (props: StyleProps) => {
  if (props.type === 'success') return success

  return
}

const getSizeStyles = (size: StyleProps['size']) => {
  if (size === 'small') return '12px'
  return '14px'
}

const getSpaceStyles = (space: StyleProps['space']) => {
  if (space === 'full') return full
}

const Wrapper = styled.div<StyleProps>`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 24px;
  color: ${colors.grey56};
  cursor: not-allowed !important;
  ${props => getTypeStyles(props)};
  ${props => getSpaceStyles(props.space)};
`

const StatusText: React.FC<StatusBadgeProps> = ({
  type = 'default',
  size = 'medium',
  space = 'fit',
  title,
  toolTipIcon,
  tooltip,
  tooltipTheme,
  isLocked
}) => {
  const randomWords = '***** ******** *****'

  return tooltip ? (
    <Tooltip content={tooltip} theme={tooltipTheme} openOnClick>
      <Wrapper type={type}>
        {toolTipIcon && <Icon id="info_blue2" width={15} height={15} />}
        <Label fontSize={getSizeStyles(size)} isLocked={isLocked}>
          {isLocked ? randomWords : title}
        </Label>
      </Wrapper>
    </Tooltip>
  ) : (
    <Wrapper type={type} space={space}>
      <Label fontSize={getSizeStyles(size)} isLocked={isLocked}>
        {isLocked ? randomWords : title}
      </Label>
    </Wrapper>
  )
}

export default StatusText
